import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import DialogWithConfirmationLayout from '@Containers/Dialogs/DialogsWithIcon/DialogWithConfirmationLayout';
import { headerString, message } from './FilterByValueConfirmDialogConstants';

export default function FilterByValueConfirmDialog(props) {
  const { filter, selfClose, toggleFilterUserInput, updateFilterUserInputValue } = props;

  return (
    <DialogWithConfirmationLayout
      {...props}
      onYesClick={() => {
        toggleFilterUserInput(filter);
        updateFilterUserInputValue(filter, '');
        selfClose();
      }}
      closeBtn={false}
      header={headerString}>
      {message}
    </DialogWithConfirmationLayout>
  );
}

FilterByValueConfirmDialog.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  selfClose: PropTypes.func.isRequired,
  toggleFilterUserInput: PropTypes.func.isRequired,
  updateFilterUserInputValue: PropTypes.func.isRequired,
};
